export enum PortalDisplayPage {
    PlaceOrder = 1,
    ProductDetail = 2,
    ShoppingCart = 3,
    Shipping = 4,
    Delivery = 5,
    Payment = 6,
    CartSummary = 7,
    OrderSummary = 8
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/portal-display-page.enum.ts